module.exports = __webpack_public_path__ + "img/Stickers-zeker-slagen.89ff366.png";